import { useEffect } from 'react'
import { useConfig } from '../contexts/ConfigContext'
import { useAuth } from '../hooks/useAuth'
import { identifyUser, startAnalytics } from './analytics'

/** Starts analytics once the app config says it is on, and keeps the
 *  signed-in user and workspace attached. Renders nothing. */
export default function AnalyticsTracker() {
    const { analytics } = useConfig()
    const { user, activeTenant } = useAuth()
    const key = analytics?.posthogKey
    const host = analytics?.posthogHost
    const environment = analytics?.environment
    const userId = user?.id
    const roles = user?.roles?.join(',')
    const tenantSlug = activeTenant?.slug

    useEffect(() => {
        if (!key) return
        let cancelled = false
        startAnalytics({
            posthogKey: key,
            posthogHost: host,
            environment,
        }).then((client) => {
            if (cancelled || !client) return
            identifyUser(
                userId ? { id: userId, roles: roles?.split(',') } : null,
                tenantSlug
            )
        })
        return () => {
            cancelled = true
        }
    }, [key, host, environment, userId, roles, tenantSlug])

    return null
}
